import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import SettingSidebar from "../components/Setttingsidebar";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axios from "axios";
import "../App.css";
import { ApiUrl } from '../Constants/Weburl';
import CustomContainer from "../components/Customsettingscontain";
import CustomButton from "../components/CustomButton";
import CustomTable from "../components/CustomTable";
import DeleteModal from "../components/DeleteModal";
import Layout from "../components/Layout";
import SettingsPageShell from "../components/SettingsMenu";

// export default function Adminwithdraw() {
//   const [title, setTitle] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [gateways, setGateways] = useState([]);

//   // Add / Edit modal
//   const [showModal, setShowModal] = useState(false);

//   // Edit ID
//   const [editGatewayId, setEditGatewayId] = useState(null);

//   // Delete modal
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);



//   // =========================
//   // FETCH GATEWAYS
//   // =========================
//   const fetchGateways = async () => {
//     try {
//       const res = await axios.get(
//         `${ApiUrl}api/getgateways`
//       );

//       console.log("res getgateways", res.data);

//       setGateways(res.data.data);
//     } catch (err) {
//       console.error("Error fetching gateways", err);
//     }
//   };

//   useEffect(() => {
//     fetchGateways();
//   }, []);

//   // =========================
//   // ADD GATEWAY
//   // =========================
//   const handleAdd = () => {
//     setEditGatewayId(null);
//     setTitle("");
//     setShowModal(true);
//   };

//   // =========================
//   // EDIT GATEWAY
//   // =========================
//   const handleEdit = (item) => {
//     setEditGatewayId(item.id);
//     setTitle(item.title);
//     setShowModal(true);
//   };


//   const closeGatewayModal = () => {
//     setShowModal(false);
//     setEditGatewayId(null);
//     setTitle("");
//   };

//   // =========================
//   // ADD / UPDATE
//   // =========================
//   const handleSubmit = async () => {
//     if (!title.trim()) {
//       alert("Gateway title is required");
//       return;
//     }

//     try {
//       setLoading(true);

//       let response;

//       if (editGatewayId) {
//         // UPDATE
//         response = await axios.put(
//           `${ApiUrl}api/updategateway/${editGatewayId}`,
//           {
//             title: title.trim(),
//           }
//         );
//       } else {
//         // ADD
//         response = await axios.post(
//           `${ApiUrl}api/create`,
//           {
//             title: title.trim(),
//           }
//         );
//       }

//       console.log("Gateway response", response.data);

//       alert(
//         response.data.message ||
//         (editGatewayId
//           ? "Gateway updated successfully"
//           : "Gateway created successfully")
//       );

//       await fetchGateways();

//       closeGatewayModal();

//     } catch (error) {
//       console.error(
//         "Gateway save error:",
//         error
//       );

//       alert(
//         error.response?.data?.message ||
//         "Something went wrong"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // =========================
//   // OPEN DELETE MODAL
//   // =========================
//   const handleDeleteClick = (id) => {
//     setDeleteId(id);
//     setShowDeleteModal(true);
//   };

//   // =========================
//   // DELETE GATEWAY
//   // =========================
//   const handleDelete = async () => {
//     if (!deleteId) return;

//     try {
//       const response = await axios.delete(
//         `${ApiUrl}api/deletegateway/${deleteId}`
//       );

//       console.log(
//         "Delete gateway response",
//         response.data
//       );

//       await fetchGateways();

//       setShowDeleteModal(false);
//       setDeleteId(null);

//     } catch (err) {
//       console.error(
//         "Delete error",
//         err
//       );

//       alert(
//         err.response?.data?.message ||
//         "Failed to delete gateway"
//       );
//     }
//   };

//   return (

//     <Layout>
//       <SettingsPageShell
//         title="Withdrawal Gateways"
//         headerRight={
//           <button className="rr-add-btn" onClick={handleAdd}>
//             Add Gateways
//           </button>
//         }
//       >
//         {loading ? (
//           <div className="rr-card">
//             <p>Loading...</p>
//           </div>
//         ) : (

//           <div className="rr-card">

//             <div className="rr-controls">

//               <div className="rr-left">
//                 Show

//                 <select className="rr-select">
//                   <option>10</option>
//                   <option>25</option>
//                   <option>50</option>
//                 </select>

//                 entries
//               </div>

//               <div className="rr-right">
//                 <span>Search:</span>

//                 <input
//                   className="rr-search"
//                   type="text"
//                   placeholder="Search..."
//                 />
//               </div>

//             </div>

//             <table className="rr-table">

//               <thead>
//                 <tr>
//                   <th>Title</th>

//                   <th className="rr-action-col">
//                     Action
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {gateways.map((item) => (
//                   <tr key={item.id}>

//                     <td>
//                       {item.title}
//                     </td>

//                     <td className="rr-actions">

//                       {/* EDIT */}
//                       <button
//                         className="rr-icon-btn green"
//                         onClick={() =>
//                           handleEdit(item)
//                         }
//                       >
//                         <i className="bi bi-pencil"></i>
//                       </button>

//                       {/* DELETE */}
//                       <button
//                         className="rr-icon-btn red"
//                         onClick={() =>
//                           handleDeleteClick(item.id)
//                         }
//                       >
//                         <i className="bi bi-trash"></i>
//                       </button>

//                     </td>

//                   </tr>
//                 ))}
//               </tbody>

//             </table>

//             {/* =========================
//                   FOOTER
//               ========================= */}
//             <div className="rr-footer">

//               <span>
//                 Showing 1 to {gateways.length} of{" "}
//                 {gateways.length} entries
//               </span>

//               <div className="rr-pagination">
//                 <span className="rr-page-arrow">
//                   &lt;
//                 </span>

//                 <span className="rr-page active">
//                   1
//                 </span>

//                 <span className="rr-page-arrow">
//                   &gt;
//                 </span>
//               </div>

//             </div>

//           </div>
//         )}

//         <Modal
//           show={showModal}
//           onHide={closeGatewayModal}
//           centered
//           className="hashtag-add-modal"
//         >
//           <Modal.Header className="hashtag-modal-header">

//             <Modal.Title>
//               {editGatewayId
//                 ? "Edit Withdrawal Gateway"
//                 : "Add Withdrawal Gateway"}
//             </Modal.Title>

//             <CustomButton
//               type="button"
//               className="hashtag-close-btn"
//               onClick={closeGatewayModal}
//             >
//               ×
//             </CustomButton>

//           </Modal.Header>

//           <Modal.Body className="hashtag-modal-body">

//             <Form.Group>

//               <Form.Label className="profile-pill">
//                 Gateway Title
//               </Form.Label>

//               <Form.Control
//                 type="text"
//                 placeholder="Enter gateway title"
//                 value={title}
//                 onChange={(e) =>
//                   setTitle(e.target.value)
//                 }
//               />

//             </Form.Group>

//           </Modal.Body>

//           <Modal.Footer className="hashtag-modal-footer">

//             <CustomButton
//               className="hashtag-close-footer-btn"
//               variant="secondary"
//               onClick={closeGatewayModal}
//             >
//               Cancel
//             </CustomButton>

//             <CustomButton
//               variant="primary"
//               className="hashtag-save-btn"
//               onClick={handleSubmit}
//               disabled={loading}
//             >
//               {loading
//                 ? "Saving..."
//                 : editGatewayId
//                   ? "Update"
//                   : "Submit"}
//             </CustomButton>

//           </Modal.Footer>
//         </Modal>


//         <DeleteModal
//           show={showDeleteModal}
//           close={() => {
//             setShowDeleteModal(false);
//             setDeleteId(null);
//           }}
//           onDelete={handleDelete}
//           title="Delete Withdrawal Gateway"
//           message="Are you sure you want to delete this withdrawal gateway?"
//         />
//       </SettingsPageShell>
//     </Layout>
//   );
// }



//current code
// export default function Adminwithdraw() {
//   const [loading, setLoading] = useState(false);
//   const [addons, setAddons] = useState([]);

//   // Edit modal
//   const [showModal, setShowModal] = useState(false);
//   const [editingAddon, setEditingAddon] = useState(null);
//   const [formValues, setFormValues] = useState({});
//   const [saving, setSaving] = useState(false);

//   // Disable/enable confirm modal (replaces old delete modal)
//   const [showToggleModal, setShowToggleModal] = useState(false);
//   const [toggleTarget, setToggleTarget] = useState(null);
  

//   // =========================
//   // FETCH GATEWAYS (from addon files, not manual DB rows)
//   // =========================
//   const fetchGateways = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${ApiUrl}api/gateways/addons`);
//       console.log("res gateways/addons", res.data);
//       setAddons(res.data.addons);
//     } catch (err) {
//       console.error("Error fetching gateways", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchGateways();
//   }, []);

//   // =========================
//   // EDIT (opens credential form, not a title field)
//   // =========================
//   const handleEdit = async (addon) => {
//     setEditingAddon(addon);
//     setFormValues({});
//     setShowModal(true);

//     if (!addon.manual) {
//       try {
//         const res = await axios.get(
//           `${ApiUrl}api/gateways/${addon.key}/credentials`
//         );
//         console.log("edit credentials API response:", res.data);
//         setFormValues(res.data.credentials || {});
//       } catch (err) {
//         console.error("Error fetching credentials", err);
//       }
//     }
//   };

//   const closeGatewayModal = () => {
//     setShowModal(false);
//     setEditingAddon(null);
//     setFormValues({});
//   };

//   // =========================
//   // SAVE CREDENTIALS
//   // =========================
//   // const handleSubmit = async () => {
//   //   if (!editingAddon) return;

//   //   try {
//   //     setSaving(true);
//   //     const response = await axios.post(
//   //       `${ApiUrl}api/gateways/${editingAddon.key}/credentials`,
//   //       { credentials: formValues }
//   //     );

//   //     alert(response.data.message || "Gateway settings saved successfully");

//   //     await fetchGateways();
//   //     closeGatewayModal();
//   //   } catch (error) {
//   //     console.error("Gateway save error:", error);
//   //     alert(error.response?.data?.message || "Something went wrong");
//   //   } finally {
//   //     setSaving(false);
//   //   }
//   // };

//   const handleSubmit = async () => {
//     if (!editingAddon) return;

//     try {
//       setSaving(true);

//       // NEW — masked password fields ('••••••••') admin touch pannala na,
//       // andha field-a payload la irundhu remove pannunga (backend existing value retain pannum)
//       const payload = { ...formValues };

//       editingAddon.credentialFields?.forEach((field) => {
//         if (payload[field.name] === "••••••••") {
//           delete payload[field.name];
//         }
//       });

//       const response = await axios.post(
//         `${ApiUrl}api/gateways/${editingAddon.key}/credentials`,
//         { credentials: payload } 
//       );

//       alert(response.data.message || "Gateway settings saved successfully");

//       await fetchGateways();
//       closeGatewayModal();
//     } catch (error) {
//       console.error("Gateway save error:", error);
//       alert(error.response?.data?.message || "Something went wrong");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // =========================
//   // DISABLE / ENABLE (instead of delete — keeps DB row + credentials safe)
//   // =========================
//   const handleToggleClick = (addon) => {
//     setToggleTarget(addon);
//     setShowToggleModal(true);
//   };

//   const handleToggleConfirm = async () => {
//     if (!toggleTarget) return;

//     try {
//       const newStatus = toggleTarget.status === "active" ? "inactive" : "active";

//       const response = await axios.put(
//         `${ApiUrl}api/gateways/${toggleTarget.key}/status`,
//         { status: newStatus }
//       );

//       console.log("Toggle gateway status", response.data);

//       await fetchGateways();
//       setShowToggleModal(false);
//       setToggleTarget(null);
//     } catch (err) {
//       console.error("Toggle error", err);
//       alert(err.response?.data?.message || "Failed to update gateway status");
//     }
//   };

//   return (
//     <Layout>
//       <SettingsPageShell title="Withdrawal Gateways">
//         {loading ? (
//           <div className="rr-card">
//             <p>Loading...</p>
//           </div>
//         ) : (
//           <div className="rr-card">
//             <div className="rr-controls">
//               <div className="rr-left">
//                 Show
//                 <select className="rr-select">
//                   <option>10</option>
//                   <option>25</option>
//                   <option>50</option>
//                 </select>
//                 entries
//               </div>

//               <div className="rr-right">
//                 <span>Search:</span>
//                 <input className="rr-search" type="text" placeholder="Search..." />
//               </div>
//             </div>

//             <table className="rr-table">
//               <thead>
//                 <tr>
//                   <th>Title</th>
//                   <th>Status</th>
//                   <th className="rr-action-col">Action</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {addons.map((item) => (
//                   <tr key={item.key}>
//                     <td>{item.title}</td>
//                     <td>{item.status === "active" ? "Active" : "Inactive"}</td>

//                     <td className="rr-actions">
//                       {/* EDIT */}
//                       <button
//                         className="rr-icon-btn green"
//                         onClick={() => handleEdit(item)}
//                       >
//                         <i className="bi bi-pencil"></i>
//                       </button>

//                       {/* DISABLE/ENABLE (replaces delete) */}
//                       <button
//                         className="rr-icon-btn red"
//                         onClick={() => handleToggleClick(item)}
//                       >
//                         <i className={item.status === "active" ? "bi bi-toggle-on" : "bi bi-toggle-off"}></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             <div className="rr-footer">
//               <span>
//                 Showing 1 to {addons.length} of {addons.length} entries
//               </span>

//               <div className="rr-pagination">
//                 <span className="rr-page-arrow">&lt;</span>
//                 <span className="rr-page active">1</span>
//                 <span className="rr-page-arrow">&gt;</span>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* EDIT MODAL — dynamic credential fields */}
//         <Modal
//           show={showModal}
//           onHide={closeGatewayModal}
//           centered
//           className="hashtag-add-modal"
//         >
//           <Modal.Header className="hashtag-modal-header">
//             {/* <Modal.Title>{editingAddon?.title} Settings</Modal.Title> */}
//             <Modal.Title>{editingAddon?.Label} Settings</Modal.Title>
//             <CustomButton
//               type="button"
//               className="hashtag-close-btn"
//               onClick={closeGatewayModal}
//             >
//               ×
//             </CustomButton>
//           </Modal.Header>

//           <Modal.Body className="hashtag-modal-body">
//             {editingAddon?.manual && editingAddon?.credentialFields?.length === 0 ? (
//               <p>
//                 This gateway is manual — admin pays directly via UPI/bank.
//                 No credentials required.
//               </p>
//             ) : (
//               editingAddon?.credentialFields?.map((field) => (
//                 <Form.Group key={field.name} className="mb-3">
//                   <Form.Label className="profile-pill">{field.label}</Form.Label>
//                   <Form.Control
//                      type="password"
//                     placeholder={`Enter ${field.label}`}
//                     value={formValues[field.name] || ""}
//                     onChange={(e) =>
//                       setFormValues({ ...formValues, [field.name]: e.target.value })
//                     }
//                   />
//                 </Form.Group>
//               ))
//             )}
//           </Modal.Body>

//           <Modal.Footer className="hashtag-modal-footer">
//             <CustomButton
//               className="hashtag-close-footer-btn"
//               variant="secondary"
//               onClick={closeGatewayModal}
//             >
//               Cancel
//             </CustomButton>

//             {!(editingAddon?.manual && editingAddon?.credentialFields?.length === 0) && (
//               <CustomButton
//                 variant="primary"
//                 className="hashtag-save-btn"
//                 onClick={handleSubmit}
//                 disabled={saving}
//               >
//                 {saving ? "Saving..." : "Save"}
//               </CustomButton>
//             )}
//           </Modal.Footer>
//         </Modal>

//         {/* DISABLE/ENABLE CONFIRM MODAL (reuses existing DeleteModal component) */}
//         <DeleteModal
//           show={showToggleModal}
//           close={() => {
//             setShowToggleModal(false);
//             setToggleTarget(null);
//           }}
//           onDelete={handleToggleConfirm}
//           title={
//             toggleTarget?.status === "active"
//               ? "Disable Withdrawal Gateway"
//               : "Enable Withdrawal Gateway"
//           }
//           message={`Are you sure you want to ${
//             toggleTarget?.status === "active" ? "disable" : "enable"
//           } ${toggleTarget?.title}?`}
//         />
//       </SettingsPageShell>
//     </Layout>
//   );
// }




export default function Adminwithdraw() {
  const [loading, setLoading] = useState(false);
  const [addons, setAddons] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [editingAddon, setEditingAddon] = useState(null);
  const [formValues, setFormValues] = useState({});   
  const [realValues, setRealValues] = useState({});   
  const [revealed, setRevealed] = useState({});      
  const [isEditMode, setIsEditMode] = useState(false); 
  const [saving, setSaving] = useState(false);

  const [showToggleModal, setShowToggleModal] = useState(false);
  const [toggleTarget, setToggleTarget] = useState(null);

  // =========================
  // FETCH GATEWAYS
  // =========================
  const fetchGateways = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${ApiUrl}api/gateways/addons`);
      setAddons(res.data.addons);
    } catch (err) {
      console.error("Error fetching gateways", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGateways();
  }, []);

 
  const handleEdit = async (addon) => {
    setEditingAddon(addon);
    setFormValues({});
    setRealValues({});
    setRevealed({});
    setIsEditMode(false); 
    setShowModal(true);

    if (!addon.manual) {
      try {
        const res = await axios.get(`${ApiUrl}api/gateways/${addon.key}/credentials`);
        setFormValues(res.data.credentials || {}); 
      } catch (err) {
        console.error("Error fetching credentials", err);
      }
    }
  };

  const closeGatewayModal = () => {
    setShowModal(false);
    setEditingAddon(null);
    setFormValues({});
    setRealValues({});
    setRevealed({});
    setIsEditMode(false);
  };

  
  const fetchRealValue = async (fieldName) => {
    if (realValues[fieldName] !== undefined) return realValues[fieldName];

    const res = await axios.get(
      `${ApiUrl}api/gateways/${editingAddon.key}/credentials/reveal`
    );
    const val = res.data.credentials[fieldName] || "";
    setRealValues((prev) => ({ ...prev, [fieldName]: val }));
    return val;
  };

  const toggleReveal = async (fieldName) => {
    try {
      await fetchRealValue(fieldName);
      setRevealed((prev) => ({ ...prev, [fieldName]: !prev[fieldName] }));
    } catch (err) {
      console.error("Reveal error", err);
      alert("Failed to fetch credential value");
    }
  };

  const handleCopy = async (fieldName) => {
    try {
      const val = await fetchRealValue(fieldName);
      await navigator.clipboard.writeText(val);
      // alert("Copied to clipboard");
    } catch (err) {
      console.error("Copy failed", err);
      alert("Failed to copy");
    }
  };


  const handleSwitchToEdit = () => {
    setIsEditMode(true);
    setFormValues({}); // edit mode la fresh empty fields (admin new values type pannanum)
  };

  const handleSubmit = async () => {
    if (!editingAddon) return;

    try {
      setSaving(true);

      const payload = { ...formValues };

      Object.keys(payload).forEach((k) => {
        if (payload[k] === "" || payload[k] === undefined) {
          delete payload[k];
        }
      });

      const response = await axios.post(
        `${ApiUrl}api/gateways/${editingAddon.key}/credentials`,
        { credentials: payload }
      );

      console.log("response.data.message gateway", response.data.message)

      alert(response.data.message || "Gateway settings saved successfully");
      
      await fetchGateways();
      closeGatewayModal();
    } catch (error) {
      console.error("Gateway save error:", error);
      alert(error.response?.data?.message || "Something went wrong");
    } finally {
      setSaving(false);
    }
  };


  const handleToggleClick = (addon) => {
    setToggleTarget(addon);
    setShowToggleModal(true);
  };

  const handleToggleConfirm = async () => {
    if (!toggleTarget) return;
    try {
      const newStatus = toggleTarget.status === "active" ? "inactive" : "active";
      await axios.put(`${ApiUrl}api/gateways/${toggleTarget.key}/status`, { status: newStatus });
      await fetchGateways();
      setShowToggleModal(false);
      setToggleTarget(null);
    } catch (err) {
      console.error("Toggle error", err);
      alert(err.response?.data?.message || "Failed to update gateway status");
    }
  };

  return (
    <Layout>
      <SettingsPageShell title="Withdrawal Gateways">
        {loading ? (
          <div className="rr-card"><p>Loading...</p></div>
        ) : (
          <div className="rr-card">
            <table className="rr-table">
              <thead>
                <tr><th>Title</th><th>Status</th><th className="rr-action-col">Action</th></tr>
              </thead>
              <tbody>
                {addons.map((item) => (
                  <tr key={item.key}>
                    <td>{item.title}</td>
                    <td>{item.status === "active" ? "Active" : "Inactive"}</td>
                    <td className="rr-actions">
                      <button className="rr-icon-btn green" onClick={() => handleEdit(item)}>
                        <i className="bi bi-pencil"></i>
                      </button>
                      <button className="rr-icon-btn red" onClick={() => handleToggleClick(item)}>
                        <i className={item.status === "active" ? "bi bi-toggle-on" : "bi bi-toggle-off"}></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <Modal show={showModal} onHide={closeGatewayModal} centered className="hashtag-add-modal">
          <Modal.Header className="hashtag-modal-header">
            <Modal.Title>{editingAddon?.label} Settings</Modal.Title>
            <CustomButton type="button" className="hashtag-close-btn" onClick={closeGatewayModal}>×</CustomButton>
          </Modal.Header>

          <Modal.Body className="hashtag-modal-body">
            {editingAddon?.manual && editingAddon?.credentialFields?.length === 0 ? (
              <p>This gateway is manual — admin pays directly via UPI/bank. No credentials required.</p>
            ) : !isEditMode ? (
              <>
                {editingAddon?.credentialFields?.map((field) => (
                  <Form.Group key={field.name} className="mb-3">
                    <Form.Label className="profile-pill">{field.label}</Form.Label>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Form.Control
                        readOnly
                        type="text"
                        value={revealed[field.name] ? (realValues[field.name] ?? "") : "••••••••••••"}
                        style={{ flex: 1 }}
                      />
                      <i
                        className={revealed[field.name] ? "bi bi-eye-slash" : "bi bi-eye"}
                        onClick={() => toggleReveal(field.name)}
                        style={{ cursor: "pointer" }}
                      ></i>
                      <i
                        className="bi bi-copy"
                        onClick={() => handleCopy(field.name)}
                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>
                  </Form.Group>
                ))}
                <CustomButton variant="secondary" onClick={handleSwitchToEdit}>
                  Change Credentials
                </CustomButton>
              </>
            ) : (
              editingAddon?.credentialFields?.map((field) => (
                <Form.Group key={field.name} className="mb-3">
                  <Form.Label className="profile-pill">{field.label}</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder={`Enter new ${field.label}`}
                    value={formValues[field.name] || ""}
                    onChange={(e) => setFormValues({ ...formValues, [field.name]: e.target.value })}
                  />
                </Form.Group>
              ))
            )}
          </Modal.Body>

          <Modal.Footer className="hashtag-modal-footer">
            <CustomButton variant="secondary" onClick={closeGatewayModal}>Cancel</CustomButton>
            {isEditMode && (
              <CustomButton variant="primary" onClick={handleSubmit} disabled={saving}>
                {saving ? "Saving..." : "Save"}
              </CustomButton>
            )}
          </Modal.Footer>
        </Modal>

        <DeleteModal
          show={showToggleModal}
          close={() => { setShowToggleModal(false); setToggleTarget(null); }}
          onDelete={handleToggleConfirm}
          title={toggleTarget?.status === "active" ? "Disable Withdrawal Gateway" : "Enable Withdrawal Gateway"}
          message={`Are you sure you want to ${toggleTarget?.status === "active" ? "disable" : "enable"} ${toggleTarget?.title}?`}
        />
      </SettingsPageShell>
    </Layout>
  );
}